import { render, staticRenderFns } from "./RiderPending.vue?vue&type=template&id=7ad0a5d6"
import script from "./RiderPending.vue?vue&type=script&lang=js"
export * from "./RiderPending.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports